import { experimentTemplateSchema } from '@ecomm/shared-ninetailed'
import { type TypeOf, z } from '@simplisafe/ewok'

const ninetailedFeatureFlagDraftSchema = z.object({
  sys: z.object({ id: z.string() }),
  title: z.string(),
  json: z.object({
    id: z.string().optional(),
    tag: z.string()
  })
})
const experimentSchema = experimentTemplateSchema.extend({
  variants: z.object({ items: z.array(ninetailedFeatureFlagDraftSchema) })
})
export const ninetailedFeatureFlagSchemaV2 =
  ninetailedFeatureFlagDraftSchema.extend({
    __typename: z.literal('NtFeatureFlag'),
    ntExperiencesCollection: z.object({
      items: z.array(experimentSchema).default([])
    })
  })

export type NinetailedFeatureFlagSchemaV2 = TypeOf<
  typeof ninetailedFeatureFlagSchemaV2
>
